

export const convert_to_json = (formData) =>{

    // Iterar sobre las entradas de FormData y construir un objeto JavaScript
    var new_object = {};
    formData.forEach(function(value, key) {
        new_object[key] = value;
    });

    return new_object;

}

export const convert_to_string64 = () =>{
    
}

export const check_validity = (data) =>{

    // Recorrer el objeto y obtener las claves
     for (var key in data) {
         if (data.hasOwnProperty(key)) {
            if(!data[key].valid){
                return false;
            }
         }
     }
    return true;
}

/**
 * Change format numbers
 * @param {number} value example: 25000
 * @returns {"25,000"}
 */
export const formatNumber = (value) =>{

    const arrayNumber = value.toString().split("")
    
    let count = 0;
    let newformat = "";

    for(var i = arrayNumber.length - 1; i >= 0; i--){

        count++;

        if(count === 4){
            newformat = "," + newformat;
            count = 0;
        }
        newformat = arrayNumber[i] + newformat;

    }

    return newformat;
}